import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import pageStyles from "./styles/dialogStyles";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@material-ui/core";

const DialogFormComponent = ({
  show,
  title,
  text,
  subtext = "",
  leftBtText,
  rightBtText,
  funcLeft,
  funcRight,
  inputs,
  vc,
  changeVc,
  subtextLink,
  textLink,
  loadingButtons,
}) => {
  const styles = pageStyles();

  const onChangeText = (event) => {
    if (event.persist) {
      event.persist();
    }
    if (event.target) {
      changeVc({ [event.target.name]: event.target.value });
    }
  };

  const renderLinkDescription = () => {
    const startIndex = text.indexOf("[[");
    const endIndex = text.indexOf("]]");
    const linkText = text.slice(startIndex + 2, endIndex);
    const leftText = text.slice(0, startIndex);
    const rightText = text.slice(endIndex + 2);

    if (startIndex > -1) {
      return (
        <span>
          {leftText}
          <a href={textLink} target="blank">
            {linkText}
          </a>
          {rightText}
        </span>
      );
    }

    return text;
  };

  const renderLink = () => {
    const startIndex = subtext.indexOf("[[");
    const endIndex = subtext.indexOf("]]");
    const linkText = subtext.slice(startIndex + 2, endIndex);
    const leftText = subtext.slice(0, startIndex);
    const rightText = subtext.slice(endIndex + 2);

    if (startIndex > -1) {
      return (
        <span>
          {leftText}
          <a href={subtextLink} target="blank">
            {linkText}
          </a>
          {rightText}
        </span>
      );
    }

    return subtext;
  };

  return (
    <Dialog
      open={show}
      aria-labelledby="form-dialog-title"
      classes={{ paper: styles.container }}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{renderLinkDescription()}</DialogContentText>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {inputs.map(
            (item, index) =>
              item && (
                <TextField
                  key={"input-modal-" + index}
                  margin="dense"
                  label={item.label}
                  value={vc[item.value]}
                  className={inputs.length > 1 ? styles.inputs : styles.input}
                  name={item.value}
                  onChange={onChangeText}
                  type={item.type || "text"}
                  autoComplete="off"
                  placeholder={item.placeholder || ""}
                  disabled={item.disabled}
                  autoFocus={index === 0 && inputs.length > 1}
                />
              ),
          )}
        </div>
        <DialogContentText style={{ fontSize: 12, marginTop: 12 }}>
          {renderLink()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {loadingButtons ? (
          <Box sx={{ textAlign: "center", width: "100%", marginBottom: 12 }}>
            <CircularProgress size={30} />
          </Box>
        ) : (
          <>
            <Button
              onClick={funcLeft}
              color="primary"
              className={styles.buttonCancel}
            >
              {leftBtText}
            </Button>
            <Button
              onClick={funcRight}
              color="primary"
              className={styles.buttonDone}
            >
              {rightBtText}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

DialogFormComponent.defaultProps = {
  show: false,
  title: "",
  text: "",
  leftBtText: "",
  rightBtText: "",
  funcLeft: () => {},
  funcRight: () => {},
  inputs: [],
  vc: {},
  changeVc: () => {},
};

DialogFormComponent.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  leftBtText: PropTypes.string,
  rightBtText: PropTypes.string,
  funcLeft: PropTypes.func,
  funcRight: PropTypes.func,
  inputs: PropTypes.array,
  vc: PropTypes.object,
  changeVc: PropTypes.func,
};

export default DialogFormComponent;
